import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
// import contactsApp from "./contactsApp"
import { marketExcutiveCommissionCompanyReducer } from './Store';
import transactionReducer from './Transaction';
import metCompnayOrderCommissionReducer from './MarketExecutiveCompanyOrders';
import { marketExecutiveReducer } from './MarketExecutive';
import AddressDropdownReducer from './AddressDropdown';

const exportReducers = history => {
    return combineReducers({
        router: connectRouter(history),
        // contactsApp: contactsApp,
        marketExecutiveReducer:marketExecutiveReducer,
        addressDropdown: AddressDropdownReducer,
        marketExcutiveCommissionCompanyReducer:marketExcutiveCommissionCompanyReducer,
        metCompnayOrderCommissionReducer:metCompnayOrderCommissionReducer,
        transactionReducer:transactionReducer
    });
};

export default exportReducers;

